import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { contactsQueryKeys, getContacts } from '@api/contacts';
import { MIN_SEARCH_LENGTH } from '@/react/utils/searchQuery';

// Customer picker search, backed by the /api/contacts list endpoint
// (GET /api/contacts?q=&search_field=email). Returns the contacts array
// directly so callers keep the previous flat-list shape. Searches by email only
// (GRAIN-2530) via the shared search_field mechanism — the CRM contacts page's
// multi-field `q` search is unaffected. Gated at MIN_SEARCH_LENGTH so short
// terms don't run an unindexed scan (trigram floor, GRAIN-2452).
export function useSearchContacts(query: string) {
  // Empty (combobox-open, list all) or a real >=3-char search. A 1-2 char query
  // is disabled — and must NOT keep previous data, or shortening "john" -> "jo"
  // would leave the "john" matches visible/selectable (they no longer match).
  const isSearchable = query.length === 0 || query.length >= MIN_SEARCH_LENGTH;
  return useQuery({
    queryKey: contactsQueryKeys.list({ q: query, searchField: 'email' }),
    queryFn: () => getContacts({ q: query, searchField: 'email' }),
    enabled: isSearchable,
    select: (data) => data.contacts,
    placeholderData: isSearchable ? keepPreviousData : undefined,
    staleTime: 30_000,
  });
}
